export default [

     {
          path: '/translate',
          name: 'Translate',
          component: () => import("@/views/Page/Translate/Translate.vue"),
           meta: {
               title: 'Translate',
          },
     }
];